<aux-tab-group
  class="mb-8"
  [tabs]="tabs"
  [variant]="'button'"></aux-tab-group>

<router-outlet></router-outlet>
